export const isSuperAdminUser = (user) => {
  return user?.roles?.some((role) => role === "ROLE_SUPER_ADMIN") || false;
};

export const isWarehouseAdminUser = (user) => {
  return user?.roles?.some((role) => role === "ROLE_WH_ADMIN") || false;
};

export const isBetaTesterUser = (user) => {
  return user?.roles?.some((role) => role === "ROLE_BETA_TESTER") || false;
};

export const isAdminUser = (user) => {
  return user?.roles?.some((role) => role === "ROLE_ADMIN") || false;
};

// The admin tier the metrics engine reads defaults for: super admin, admin or warehouse admin. Writing is decided
// by the API (can_write), never by the front.
export const isAdminTierUser = (user) => {
  return isSuperAdminUser(user) || isAdminUser(user) || isWarehouseAdminUser(user);
};
